<template>
	<div>
		<div v-if="isJeet11Distributor" class="ma-4 text-center">
			Due to unavoidable circumstances we are disabling all offline
			transactions with immediate effect. Any balance which remains in
			distributor wallet or executive wallet or retailer wallet will be
			settled in Distributor's bank account within 7-10 working days along
			with any other pending payment. In case of any query please drop a
			mail at support@jeet11.com
		</div>
		<div v-else class="ma-4 text-center">
			Due to unavoidable circumstances we are disabling all offline
			transactions with immediate effect. Any balance which remains in
			executive wallet will be settled in Distributor's bank account
			within 7-10 working days.
		</div>
		<v-flex v-if="false" pa-2>
			<img :src="`${JEET_11_CDN_BASE_LINK}/primaryDayBannerNew.jpg`" />
		</v-flex>
		<target-banner
			v-if="false"
			:isJeet11Executive="isJeet11Executive"
			:retailSalaryData="retailSalaryData"
			:monthlyCommission="monthlyCommission"
		/>
		<div v-show="false" class="allCenteredChild">
			<img
				:src="
					require(`../../assets/${
						isRummyOptionSelected ? 'jeet11-rummy' : 'jeet11'
					}.png`)
				"
				alt="Logo"
				class="app-logo"
			/>
		</div>
		<jeet11-retailer-banners v-show="false" />

		<gmv-target-banner
			v-if="false"
			:tsmGmv="
				showPrimaryDayBanner
					? primaryDayCurrentTargets
					: isJeet11Executive
					? executiveTargetRangeGmv
					: 0
			"
			:tsmTargetGmvData="targetGmvData"
			:tsmTargetGmvDataStartDate="targetGmvDataStartDate"
			:tsmTargetGmvDataEndDate="targetGmvDataEndDate"
			:isPrimaryDayBanner="true"
			:isExecutive="isJeet11Executive"
		/>
		<!-- <v-card class="bannerCard" elevation="5" v-if="showPrimaryDayBanner">
			<div class="full-width">
				<div class="full-width">
					<div class="d-flex justify-space-between align-center">
						<div class="text-left body-2 grey--text text--darken">
							Primary Day Achievements - Recharge Value
						</div>
						<div class="text-right amt-text">
							{{ primaryDayCurrentTargets
							}}<span class="body-2 grey--text text--lighten-1"
								>/{{ primaryDayOverallTarget }}</span
							>
						</div>
					</div>
					<div class="progress-bar">
						<div
							:style="
								`width: ${Math.min(
									(primaryDayCurrentTargets /
										primaryDayOverallTarget) *
										100,
									100
								)}%`
							"
						/>
					</div>
					<div class="pt-3 d-flex justify-space-between align-center">
						<div class="text-left body-2 grey--text text--darken">
							Primary Day Achievements - No of Transactions
						</div>
						<div class="text-right amt-text">
							{{ primaryDayTransactionCount }}
						</div>
					</div>
				</div>
			</div>
		</v-card> -->

		<v-card class="main-card">
			<v-card
				tile
				class="top-card"
				:style="{ backgroundColor: themeInputColor }"
			>
				<div class="pt-3 d-flex justify-center align-center full-width">
					<div style="width: 50%">
						<div>Account Balance</div>
						<div class="amount-wrapper">
							<span class="amount-sign">&#8377;</span>
							<span>{{
								jeet11WalletBalance.toLocaleString()
							}}</span>
						</div>
					</div>
					<div class="vertical-divider" v-if="false" />
					<div style="width: 50%" v-if="false">
						<div>Total Payout</div>
						<div class="amount-wrapper">
							<span class="amount-sign">&#8377;</span>
							<span>{{
								(
									retailSalaryData.salaryPayout +
									retailSalaryData.bonusPayout
								).toLocaleString()
							}}</span>
						</div>
					</div>
				</div>
				<div class="pt-3" v-if="false">
					<div>GMV ({{ currentMonth }})</div>
					<div class="amount-wrapper">
						<span class="amount-sign">&#8377;</span>
						<span>{{
							(
								retailSalaryData.targetAchieved || ""
							).toLocaleString()
						}}</span>
					</div>
				</div>
				<div
					class="pt-3 d-flex justify-center align-center full-width"
					v-if="false"
				>
					<div style="width: 50%">
						<div>Salary Payout</div>
						<div class="amount-wrapper">
							<span class="amount-sign">&#8377;</span>
							<span>{{
								retailSalaryData.salaryPayout.toLocaleString()
							}}</span>
						</div>
					</div>
					<div class="vertical-divider" />
					<div style="width: 50%">
						<div>Bonus Payout</div>
						<div class="amount-wrapper">
							<span class="amount-sign">&#8377;</span>
							<span>{{
								retailSalaryData.bonusPayout.toLocaleString()
							}}</span>
						</div>
					</div>
				</div>
				<div v-if="false" class="pt-3">
					<div>
						Gold Membership Commission Earned (This Month)
					</div>
					<div class="amount-wrapper">
						<span class="amount-sign">&#8377;</span>
						<span>{{
							monthlyCommission.premiumCommission.toLocaleString()
						}}</span>
					</div>
				</div>
				<div class="pt-4">
					<div
						class="
							d-flex
							justify-start
							blue-grey--text
							text--lighten-3
						"
					>
						Tsm Number
					</div>
					<div class="title d-flex justify-start pt-1">
						{{ tsmNumber }}
						<!-- <v-icon style="display: contents" small color="#fff"
							>edit</v-icon
						> -->
					</div>
				</div>
			</v-card>
			<v-card tile>
				<div class="d-flex flex-column">
					<v-card
						v-if="false"
						outline
						class="menu-card"
						@click="showExecutivesRetailersList"
					>
						<div>My {{ partnerType }}s</div>
						<span class="headline">&#8250;</span>
					</v-card>
					<v-card
						v-if="false"
						outline
						class="menu-card"
						@click="addMoney"
					>
						<div>Add Money</div>
						<span class="headline">&#8250;</span>
					</v-card>
					<v-card
						outline
						class="menu-card"
						v-if="false"
						@click="addRetailer"
					>
						<div>
							Add
							{{ partnerType }}
						</div>
						<span class="headline">&#8250;</span>
					</v-card>
					<v-card
						v-show="false"
						outline
						class="menu-card"
						@click="transferJeet11"
					>
						<div>
							Transfer To
							{{ isRummyOptionSelected ? "Rummy" : "JEET 11" }}
							User
						</div>
						<span class="headline">&#8250;</span>
					</v-card>
					<v-card
						v-if="false"
						outline
						class="menu-card"
						@click="inviteRetailer"
					>
						<div>
							Invite
							{{ partnerType }}
						</div>
						<span class="headline">&#8250;</span>
					</v-card>
					<v-card outline class="menu-card" @click="seePassbook">
						<div>Passbook</div>
						<span class="headline">&#8250;</span>
					</v-card>
					<v-card
						v-show="false"
						outline
						class="menu-card"
						@click="transferJeet11"
					>
						<div>
							Transfer To
							{{ isRummyOptionSelected ? "Rummy" : "JEET 11" }}
							User
						</div>
						<span class="headline">&#8250;</span>
					</v-card>
				</div>
			</v-card>
		</v-card>
		<v-dialog width="600px" persistent v-model="addMoneyDialogBox">
			<div class="white pos-rel rounded-lg" v-if="addMoneyDialogBox">
				<div class="top-right-align pa-0 ma-n1">
					<v-btn @click="addMoneyDialogBox = false" fab flat>
						<v-icon>close</v-icon>
					</v-btn>
				</div>
				<!-- <add-money
					@ADD_MONEY="initiateAddMoney"
					:checkingStatus="checkingPaymentStatus"
					:isLoading="initiatingAddMoney"
				/> -->
				<add-money
					@ADD_MONEY="initiateAddMoney"
					:checkingStatus="checkingPaymentStatus"
					:isLoading="initiatingAddMoney"
					@CLOSE_MODAL="addMoneyDialogBox = false"
					:razorpayDetails="razorpayAccountDetails"
					:isCreationLoading="isCreationLoading"
					@CREATE_ACCOUNT="createRazorpayAccount"
					:isRummyOptionSelected="isRummyOptionSelected"
					:themeInputColor="themeInputColor"
					:paytmVanDetails="paytmVanDetails"
					@CREATE_ACCOUNT_PAYTM="createPaytmAccount"
					@ADD_TPV="addTpvDetails"
					:addTpvLoading="addTpvLoading"
				/>
			</div>
		</v-dialog>
		<v-dialog width="600px" persistent v-model="inviteRetailerDialog">
			<div class="white pos-rel rounded-lg" v-if="inviteRetailerDialog">
				<invite-retailer
					:partnerType="partnerType"
					:themeInputColor="themeInputColor"
					@CLOSE_MODAL="closeModal"
					model="inviteRetailerDialog"
				/>
			</div>
		</v-dialog>
		<v-dialog width="600px" persistent v-model="transferJeet11Dialog">
			<div>
				<transfer-money
					model="transferJeet11Dialog"
					:themeInputColor="themeInputColor"
					:searchingJeet11User="searchingJeet11User"
					:searchedUser="jeet11User"
					:payingJeet11User="pay11Jeet11UserLoadingDirect"
					:forgetMpin="forgetMpin"
					:jeet11WalletBalance="jeet11WalletBalance"
					@SEARCH_USER="searchJeet11User"
					@CLOSE_MODAL="closeModal"
					@RESET_SEARCHED_JEET11_USER="resetJeet11SearchedUser"
					@CONFIRM_AND_PAY_TO_JEET11_USER="confirmAndPayJeet11User"
					:isRummyOptionSelected="isRummyOptionSelected"
				/>
			</div>
		</v-dialog>
		<passbook-view
			@LOAD_MORE_ROWS="fetchJeet11TransactionsHistory"
			@CLOSE_MODAL="closeModal"
			:data="
				isRummyOptionSelected
					? rummyPartnerTransaction
					: jeet11PartnerTransactions
			"
			:loading="fetchingTransactions"
			model="passbookDialog"
			v-if="passbookDialog"
			:themeInputColor="themeInputColor"
			:isRummyOptionSelected="isRummyOptionSelected"
		/>
		<!-- <transaction-details
			@CLOSE_MODAL="closeModal"
			model="transactionDetailsDialog"
			v-if="transactionDetailsDialog"
			:themeInputColor="themeInputColor"
			:retailerDetails="selectedRetailerDetails"
		/> -->
		<generate-mpin
			@CLOSE_MODAL="closeModal"
			model="generateMpinDialog"
			v-if="generateMpinDialog"
			:themeInputColor="themeInputColor"
		/>
		<executives-retailers-list
			@LOAD_MORE_ROWS="fetchJeet11DistributorRetailerList"
			@CLOSE_MODAL="closeModal"
			:data="jeet11DistributorRetailerList"
			:partnerType="partnerType"
			:loading="fetchingDistributorRetailerList"
			model="executivesRetailersListDialog"
			v-if="executivesRetailersListDialog"
			:themeInputColor="themeInputColor"
			:isRummyOptionSelected="isRummyOptionSelected"
		/>
		<v-dialog
			width="600px"
			hide-overlay
			fullscreen
			v-model="addRetailerDialog"
		>
			<div class="white full-height" v-if="addRetailerDialog">
				<sign-up-form
					:isDistributorSignUp="isJeet11Distributor"
					:isExecutiveSignUp="isJeet11Executive"
					:partnerNumber="this.jeet11PartnerNumber"
					@closeSignUp="closeModal('addRetailerDialog')"
					model="addRetailerDialog"
					:themeInputColor="themeInputColor"
				/>
			</div>
		</v-dialog>
		<v-dialog width="600px" persistent v-model="editTsmDialog">
			<div class="white pos-rel rounded-lg" v-if="editTsmDialog">
				<edit-tsm-number
					:themeInputColor="themeInputColor"
					@CLOSE_MODAL="closeModal"
					@fetchJeet11WalletDetails="fetchJeet11WalletDetails"
					model="editTsmDialog"
				/>
			</div>
		</v-dialog>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
	FETCH_JEET11_PARTNER_WALLET_DETAILS,
	FETCH_JEET11_PARTNER_TRANSACTION_HISTORY,
	FETCH_JEET11_DISTRIBUTOR_RETAILER_LIST,
	PAY_JEET11_USER,
	FETCH_JEET11_USER_BY_PHONE,
	RESET_JEET11_SEARCHED_USER,
	INITIATE_PAYMENT,
	CHECK_PAYMENT_STATUS,
	SHOW_ALERT,
	FETCH_RAZORPAY_ACCOUNT_DETAILS,
	CREATE_RAZORPAY_ACCOUNT,
	FETCH_MONTHLY_COMMISSION,
	// TOGGLE_APP_MODE,
	FETCH_RUMMY_PARTNER_TRANSACTION_HISTORY
} from "@/store/action-types";
import ApiService from "@/store/api-service";
import { TOP, END } from "@/store/config";
import PassbookView from "@/components/passbook-view";
import GenerateMPIN from "../GenerateMPIN";
// import TransactionDetails from "./transaction-details";
// import SignUpForm from "./sign-up-form";
import SignUpForm from "../Landing/sign-up-form";
import InviteRetailer from "./invite-retailer";
import Jeet11RetailBanners from "../jeet11-retail-banners";
import TransferMoney from "../Jeet11/transfer-money";
import ExecutivesRetailersList from "../executives-retailers-list";
import AddMoney from "./add-money";
import EditTsmNumber from "../EditTsmNumber/edit-tsm-number";
import TargetBanner from "../TargetBanner";
import {
	FETCH_RETAIL_SALARY,
	FETCH_TSM_TARGETS
} from "../../store/action-types";
import { PAY_RUMMY_USER } from "../../store/action-types";
import { MONTHS, RUMMY_COLOUR, THEME_INPUT_COLOUR } from "../constants";
import { BASE_URL } from "../../../config";
import { JEET_11_CDN_BASE_LINK } from "@/store/config";
import GMVTargetBanner from "../TSM-landing/gmv-target-banner";
import { dd_mm_yyToyy_mm_dd } from "../../utils";

export default {
	name: "JEET11",
	data() {
		return {
			JEET_11_CDN_BASE_LINK,
			fetchingTransactions: false,
			passbookDialog: false,
			addMoneyDialogBox: false,
			TOP,
			END,
			// transactionDetailsDialog: false,
			addRetailerDialog: false,
			inviteRetailerDialog: false,
			fetchingDistributorRetailerList: false,
			transferJeet11Dialog: false,
			searchingJeet11User: false,
			pay11Jeet11UserLoadingDirect: false,
			initiatingAddMoney: false,
			amount: null,
			generateMpinDialog: false,
			checkingPaymentStatus: false,
			intervalForPaymentStatus: null,
			executivesRetailersListDialog: false,
			razorpayAccountDetailsLoading: false,
			isCreationLoading: false,
			editTsmDialog: false,
			retailSalaryData: {},
			fetchingMonthlyCommission: false,
			appToggle: 0,
			paytmVanDetailsLoading: false,
			paytmVanDetails: {},
			addTpvLoading: false,
			showPrimaryDayBanner: false,
			primaryDayCurrentTargets: 0,
			primaryDayOverallTarget: 0,
			primaryDayTransactionCount: 0,
			targetGmvData: [],
			targetGmvDataStartDate: null,
			targetGmvDataEndDate: null,
			executiveTargetRangeGmv: 0
		};
	},
	mounted() {
		this.fetchJeet11WalletDetails();
		this.fetchJeet11DistributorRetailerList(TOP);
		this.resetJeet11SearchedUser();
		this.fetchMonthlyCommission();
		if (this.isJeet11Distributor) {
			this.fetchRazorpayAccountDetails();
			this.fetchPaytmVanDetails();
			this.fetchPrimaryDayTargets();
		}
		if (this.$route.query.orderId) {
			this.startIntervalForCheckingStatus(this.$route.query.orderId);
		}
		if (this.isJeet11Executive || this.isJeet11Distributor) {
			this.fetchRetailSalary();
		}
		if (this.isRummyOptionSelected) {
			this.appToggle = 1;
		}
		if (this.isJeet11Executive) {
			this.fetchTSMTargetGmvData();
		}
	},
	beforeDestroy() {
		clearInterval(this.intervalForPaymentStatus);
	},
	components: {
		"passbook-view": PassbookView,
		// "transaction-details": TransactionDetails,
		"sign-up-form": SignUpForm,
		"invite-retailer": InviteRetailer,
		"jeet11-retailer-banners": Jeet11RetailBanners,
		"transfer-money": TransferMoney,
		"add-money": AddMoney,
		"generate-mpin": GenerateMPIN,
		"executives-retailers-list": ExecutivesRetailersList,
		"edit-tsm-number": EditTsmNumber,
		"target-banner": TargetBanner,
		"gmv-target-banner": GMVTargetBanner
	},
	computed: {
		...mapState({
			jeet11PartnerTransactions: state =>
				state.jeet11.jeet11PartnerTransactionHistory,
			jeet11WalletBalance: state =>
				state.jeet11.jeet11PartnerDetails.walletBalance || 0,
			jeet11DistributorRetailerList: state =>
				state.jeet11.jeet11DistributorRetailerList,
			jeet11PartnerRetailerTransactions: state =>
				state.jeet11.jeet11PartnerRetailerTransactionHistory,
			jeet11PartnerNumber: state =>
				state.jeet11.jeet11PartnerDetails.phoneNo
					? state.jeet11.jeet11PartnerDetails.phoneNo
					: null,
			jeet11User: state => state.jeet11.jeet11User,
			razorpayAccountDetails: state =>
				state.jeet11.razorpayAccountDetails,
			monthlyCommission: state => state.jeet11.monthlyCommission,
			tsmNumber: state =>
				state.jeet11.jeet11PartnerDetails.tsmNumber || "_________",
			rummyPartnerTransaction: state =>
				state.rummy.rummyPartnerTransactionHistory,
			ACCESS_TOKEN: state => state.auth.ACCESS_TOKEN
		}),
		...mapGetters({
			isJeet11Distributor: "auth/isJeet11Distributor",
			isJeet11Executive: "auth/isJeet11Executive"
		}),
		isSmallScreen() {
			return this.$vuetify.breakpoint.name === "xs";
		},
		partnerType() {
			return this.isJeet11Distributor ? "executive" : "retailer";
		},
		themeInputColor() {
			return this.isRummyOptionSelected
				? RUMMY_COLOUR
				: THEME_INPUT_COLOUR;
		},
		currentMonth() {
			const today = new Date();
			return MONTHS[[today.getMonth()]];
		}
	},
	props: ["isRummyOptionSelected"],
	methods: {
		async fetchPrimaryDayTargets() {
			const payload = {
				access_token: this.ACCESS_TOKEN,
				params: {}
			};
			const endpoint = `${BASE_URL}/jeet11-retail/v1.0.0/userPrimaryDay`;
			const response = await ApiService.post(endpoint, payload);
			const { statusCode, response: data } = response;
			if (statusCode === 200) {
				const { jeet11, rummy } = data;
				const variableToUse = this.isRummyOptionSelected
					? rummy
					: jeet11;
				if (variableToUse && Object.keys(variableToUse).length > 0) {
					this.primaryDayOverallTarget = variableToUse.targetAmount;
					this.fetchTSMTargetGmvData();
					this.fetchCurrentPrimaryDayTargets();
				}
			}
		},
		async fetchCurrentPrimaryDayTargets() {
			const payload = {
				access_token: this.ACCESS_TOKEN,
				params: {
					appName: this.isRummyOptionSelected ? "GAMES" : "JEET11",
					startDate: new Date().toISOString().slice(0, 10),
					endDate: new Date().toISOString().slice(0, 10)
				}
			};
			const endpoint = `${BASE_URL}/jeet11-retail/v1.0.0/primaryDayAchievement`;
			const response = await ApiService.post(endpoint, payload);
			const { response: data } = response;
			const { primaryDayRecharge, entryCount } = data;
			this.primaryDayCurrentTargets = primaryDayRecharge;
			this.primaryDayTransactionCount = entryCount;
			if (primaryDayRecharge >= 0) this.showPrimaryDayBanner = true;
		},
		transferJeet11() {
			this.transferJeet11Dialog = true;
		},
		searchJeet11User(payload) {
			if (!this.searchingJeet11User) {
				this.searchingJeet11User = true;
				this.$store
					.dispatch(FETCH_JEET11_USER_BY_PHONE.dispatch, payload)
					.catch(() => {})
					.then(() => (this.searchingJeet11User = false));
			}
		},
		confirmAndPayJeet11User(payload) {
			if (!this.pay11Jeet11UserLoadingDirect) {
				this.pay11Jeet11UserLoadingDirect = true;
				this.$store
					.dispatch(
						this.isRummyOptionSelected
							? PAY_RUMMY_USER.dispatch
							: PAY_JEET11_USER.dispatch,
						{
							...payload,
							isJeet11Transfer: true
						}
					)
					.catch(() => {})
					.then(() => {
						this.pay11Jeet11UserLoadingDirect = false;
						this.transferJeet11Dialog = false;
						this.fetchJeet11WalletDetails();
					});
			}
		},
		fetchTSMTargetGmvData() {
			this.$store
				.dispatch(FETCH_TSM_TARGETS.dispatch, {
					appType: this.isRummyOptionSelected ? "RUMMY" : "JEET11"
				})
				.then(resp => {
					const { targets, startDate, endDate } = resp;
					this.targetGmvData = targets;
					this.targetGmvDataStartDate = startDate;
					this.targetGmvDataEndDate = endDate;
					if (startDate && endDate) {
						this.fetchRetailSalary(
							dd_mm_yyToyy_mm_dd(startDate),
							dd_mm_yyToyy_mm_dd(endDate)
						);
					}
				})
				.catch(err => console.log(err));
		},
		resetJeet11SearchedUser() {
			this.$store.dispatch(RESET_JEET11_SEARCHED_USER.dispatch);
		},
		fetchJeet11WalletDetails() {
			this.$store.dispatch(FETCH_JEET11_PARTNER_WALLET_DETAILS.dispatch, {
				isSchemeRequired: true,
				isCardGame: this.isRummyOptionSelected ? 1 : 0
			});
		},
		fetchJeet11DistributorRetailerList(payload) {
			if (!this.fetchingDistributorRetailerList) {
				this.fetchingDistributorRetailerList = true;
				this.$store
					.dispatch(
						FETCH_JEET11_DISTRIBUTOR_RETAILER_LIST.dispatch,
						payload
					)
					.catch(() => {})
					.then(() => {
						this.fetchingDistributorRetailerList = false;
					});
			}
		},
		fetchJeet11TransactionsHistory(payload) {
			if (!this.fetchingTransactions) {
				this.fetchingTransactions = true;
				this.$store
					.dispatch(
						this.isRummyOptionSelected
							? FETCH_RUMMY_PARTNER_TRANSACTION_HISTORY.dispatch
							: FETCH_JEET11_PARTNER_TRANSACTION_HISTORY.dispatch,
						payload
					)
					.catch(() => {})
					.then(() => {
						this.fetchingTransactions = false;
					});
			}
		},
		seePassbook() {
			this.fetchJeet11TransactionsHistory(TOP);
			this.passbookDialog = true;
		},
		addRetailer() {
			this.addRetailerDialog = true;
		},
		inviteRetailer() {
			this.inviteRetailerDialog = true;
		},
		forgetMpin() {
			this.generateMpinDialog = true;
		},
		editTsmNumber() {
			this.editTsmDialog = true;
		},
		// addTransaction() {
		// 	this.transactionDetailsDialog = true;
		// },
		showExecutivesRetailersList() {
			this.executivesRetailersListDialog = true;
		},
		closeModal(payload) {
			this[payload] = false;
		},
		showAlert(message) {
			this.$store.dispatch(SHOW_ALERT.dispatch, {
				text: message
			});
		},
		initiateAddMoney(amount) {
			if (!this.initiatingAddMoney) {
				this.initiatingAddMoney = true;
				this.$store
					.dispatch(INITIATE_PAYMENT.dispatch, {
						amount: Number(amount),
						walletCategory: this.isRummyOptionSelected
							? "games"
							: null
					})
					.finally(() => {
						this.initiatingAddMoney = false;
					});
			}
		},
		startIntervalForCheckingStatus(orderId) {
			const times = 150; // 2m 30s
			let current = 0;
			this.intervalForPaymentStatus = setInterval(() => {
				if (current === times) {
					this.addMoneyDialogBox = false;
					clearInterval(this.intervalForPaymentStatus);
					this.showAlert("Payment is not confirmed!");
					this.checkingPaymentStatus = false;
				} else if (current % 5 === 0) {
					this.checkForPaymentStatus(orderId);
				}
				current++;
			}, 1000);
		},
		checkForPaymentStatus(orderId) {
			this.initiatingAddMoney = false;
			this.checkingPaymentStatus = true;
			this.$store
				.dispatch(CHECK_PAYMENT_STATUS.dispatch, {
					orderId,
					mode: "razorpay"
				})
				.then(({ status }) => {
					if (status === "success" || status === "failed") {
						this.checkingPaymentStatus = false;
						this.showAlert(
							status === "success"
								? "Payment Success!"
								: "Payment Failed!"
						);
						clearInterval(this.intervalForPaymentStatus);
						this.addMoneyDialogBox = false;
						this.fetchJeet11WalletDetails();
						this.$router.replace({ query: null });
					}
				})
				.catch(() => {
					this.checkingPaymentStatus = false;
					this.addMoneyDialogBox = false;
					clearInterval(this.intervalForPaymentStatus);
					this.showAlert("Payment is not confirmed!");
					this.$router.replace({ query: null });
				});
		},
		addMoney() {
			this.addMoneyDialogBox = true;
		},
		showRetailerUsers(retailer) {
			this.$router.push({
				path: "retailer-users",
				query: { id: retailer.userId }
			});
		},
		fetchRazorpayAccountDetails() {
			if (!this.razorpayAccountDetailsLoading) {
				this.razorpayAccountDetailsLoading = true;
				this.$store
					.dispatch(FETCH_RAZORPAY_ACCOUNT_DETAILS.dispatch)
					.then(() => {
						this.razorpayAccountDetailsLoading = false;
					})
					.catch(() => {
						this.razorpayAccountDetailsLoading = false;
						this.showAlert("Could not fetch Razorpay details");
					});
			}
		},
		async fetchPaytmVanDetails() {
			if (!this.paytmVanDetailsLoading) {
				this.paytmVanDetailsLoading = true;
				const payload = {
					access_token: this.ACCESS_TOKEN,
					params: {
						appName: this.isRummyOptionSelected ? "GAMES" : "JEET11"
					}
				};
				const endpoint = `${BASE_URL}/jeet11-retail/v1.0.0/getPaytmVirtualAccount`;
				const response = await ApiService.post(endpoint, payload);
				const { code, status, response: data } = response;
				if (code === 200 && status === "success") {
					this.paytmVanDetails = data;
				} else {
					this.showAlert("Could not get Paytm VAN Details");
					this.paytmVanDetails = {};
				}
				this.paytmVanDetailsLoading = false;
			}
		},
		createRazorpayAccount(details) {
			if (!this.isCreationLoading) {
				this.isCreationLoading = true;
				this.$store
					.dispatch(CREATE_RAZORPAY_ACCOUNT.dispatch, details)
					.then(() => {
						this.isCreationLoading = false;
					})
					.catch(() => {
						this.isCreationLoading = false;
						this.showAlert("Could not fetch Razorpay details");
					});
			}
		},
		async createPaytmAccount(details) {
			if (!this.isCreationLoading) {
				this.isCreationLoading = true;
				const payload = {
					access_token: this.ACCESS_TOKEN,
					params: {
						...details,
						appName: this.isRummyOptionSelected
							? "GAMES"
							: "JEET11",
						tpvList: []
					}
				};
				const endpoint = `${BASE_URL}/jeet11-retail/v1.0.0/createPaytmVirtualAccount`;
				const response = await ApiService.post(endpoint, payload);
				const { code, status } = response;
				if (code === 200 && status === "success") {
					this.fetchPaytmVanDetails();
				} else {
					this.showAlert("Could not create Paytm VAN");
					this.paytmVanDetails = {};
				}
				this.isCreationLoading = false;
			}
		},
		async addTpvDetails(details) {
			if (!this.addTpvLoading) {
				this.addTpvLoading = true;
				const payload = {
					access_token: this.ACCESS_TOKEN,
					params: {
						van: this.paytmVanDetails.vanNumber,
						isActive: this.paytmVanDetails.isActive,
						tpvList: [details]
					}
				};
				const endpoint = `${BASE_URL}/jeet11-retail/v1.0.0/updatePaytmVirtualAccount`;
				const response = await ApiService.post(endpoint, payload);
				const { code, status } = response;
				if (code === 200 && status === "success") {
					this.fetchPaytmVanDetails();
				} else {
					this.showAlert("Could not add account");
				}
				this.addTpvLoading = false;
			}
		},
		fetchRetailSalary(startDate, endDate) {
			const date = new Date();
			const startDateForReq = new Date(
				date.getFullYear(),
				date.getMonth(),
				1
			);
			const endDateForReq = new Date(
				date.getFullYear(),
				date.getMonth() + 1,
				0
			);
			this.$store
				.dispatch(FETCH_RETAIL_SALARY.dispatch, {
					startDate:
						startDate ||
						new Date(startDateForReq.getTime() + 330 * 60000)
							.toISOString()
							.substr(0, 10),
					endDate:
						endDate ||
						new Date(endDateForReq.getTime() + 330 * 60000)
							.toISOString()
							.substr(0, 10),
					appType: this.isRummyOptionSelected ? "RUMMY" : "JEET11"
				})
				.catch(() => {})
				.then(data => {
					if (startDate && endDate) {
						this.executiveTargetRangeGmv = data.targetAchieved;
					} else {
						this.retailSalaryData = data;
					}
				});
		},
		fetchMonthlyCommission() {
			if (!this.fetchingMonthlyCommission) {
				this.fetchingMonthlyCommission = true;
				this.$store
					.dispatch(FETCH_MONTHLY_COMMISSION.dispatch)
					.catch(() => {})
					.then(() => {
						this.fetchingMonthlyCommission = false;
					});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.amount-wrapper {
	font-weight: 500;
	font-size: 32px;
	line-height: 37px;
	display: flex;
	align-items: center;
}
.amount-sign {
	font-size: 24px;
	line-height: 28px;
	color: #e4f1ff;
	opacity: 0.6;
	padding-right: 0.3em;
}
.main-card {
	border-radius: 24px 24px 0px 0px;
	margin-top: 2em;
	color: #575f6b;
}
.top-card {
	padding: 2em 1em;
	color: #fff;
}
.menu-card {
	color: #575f6b;
	font-size: 14px;
	line-height: 16px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 1em;
	cursor: pointer;
}
.rounded-lg {
	border-radius: 16px;
}
.vertical-divider {
	border: 1px solid;
	border-image-source: linear-gradient(
		270deg,
		rgba(255, 255, 255, 0) 0%,
		#ffffff 51.59%,
		rgba(255, 255, 255, 0) 100%
	);
	opacity: 0.5;
	transform: rotate(90deg);
	margin: 0px 0px;
	width: 56px;
	height: 0px;
}
.app-logo {
	height: 80px;
	object-fit: contain;
}
</style>
